import { autorun, makeAutoObservable, runInAction } from 'mobx';
import { getSamplesByStorage } from 'services/sample.services';

const NAME = 'sample-v2-store';

export class StorageStore {
  samples = [];
  selectedSample = null;
  pagination = {
    itemsCount: 0,
    limit: 0,
    page: 1,
    pagesCount: 1,
  };
  columns = [];
  icons = [];
  selectedEmptyCellForCopy = [];
  selectedSamplesForCopy = [];
  selectedCell = [];
  options = null;
  sensors = [];

  constructor() {
    makeAutoObservable(this);

    const storeJSON = localStorage.getItem(NAME);

    if (storeJSON) Object.assign(this, JSON.parse(storeJSON));

    autorun(() => {
      const obj = JSON.parse(JSON.stringify(this));
      localStorage.setItem(NAME, JSON.stringify(obj));
    });

    window.addEventListener('storage', this._updateStore);
  }

  _updateStore = (e) => {
    if (e.key === NAME) {
      const storeJSON = localStorage.getItem(NAME);

      if (storeJSON) Object.assign(this, JSON.parse(storeJSON));
    }
  };

  _dispose = () => {
    window.removeEventListener('storage', this._updateStore);
  };

  getSamples = async (options) => {
    const response = await getSamplesByStorage(options);
    runInAction(() => {
      this.options = options;
      this.samples = response.data;
      this.pagination = {
        page: response?.pagination?.page,
        pagesCount: response?.pagination?.pages_count,
        itemsCount: response?.pagination?.items_count,
        limit: response?.pagination?.limit,
      };
      this.columns = response?.table;
      if (options.type === 'storage_pack') {
        this.refreshSelectedCells(options.id);
      }
    });
  };

  refreshSamples = async () => {
    await this.getSamples(this.options);
  };

  refreshSelectedCells = (packId) => {
    runInAction(() => {
      this.selectedEmptyCellForCopy = this.selectedEmptyCellForCopy.filter(
        (i) =>
          i.packId !== packId ||
          !this.samples.find((sample) => sample.line === i.line && sample.column === i.column),
      );
    });
  };

  setSelectedEmptyCellForCopy = (cell) => {
    runInAction(() => {
      this.selectedEmptyCellForCopy.push(cell);
    });
  };

  deleteSelectedEmptyCellForCopy = (cell) => {
    runInAction(() => {
      this.selectedEmptyCellForCopy = this.selectedEmptyCellForCopy.filter(
        (i) =>
          !(
            i.packId === cell.packId &&
            i.line === cell.line &&
            i.column === cell.column &&
            i.storageId === cell.storageId
          ),
      );
    });
  };

  clearSelectedEmptyCellForCopy = () => {
    runInAction(() => {
      this.selectedEmptyCellForCopy = [];
    });
  };

  setSelectedSamplesForCopy = (id) => {
    runInAction(() => {
      this.selectedSamplesForCopy.push(id);
    });
  };

  setSelectedSampleArrayForCopy = (array) => {
    runInAction(() => {
      this.selectedSamplesForCopy = array;
    });
  };

  deleteSelectedSamplesForCopy = (id) => {
    runInAction(() => {
      this.selectedSamplesForCopy = this.selectedSamplesForCopy.filter((i) => i !== id);
    });
  };

  clearSelectedSamplesForCopy = () => {
    runInAction(() => {
      this.selectedSamplesForCopy = [];
    });
  };

  setSelectedCell = (array) => {
    this.selectedCell = array;
  };

  editSelectedCell = (cell) => {
    const index = this.selectedCell.findIndex(
      (i) =>
        i.packId === cell.packId &&
        i.column === cell.column &&
        i.line === cell.line &&
        i.storageId === cell.storageId,
    );

    if (index !== -1) {
      this.selectedCell.splice(index, 1);
    } else {
      this.selectedCell.push(cell);
    }
  };

  setSensors = (data) => {
    const newArray = data?.data ?? [];

    newArray.forEach((item) => {
      const index = this.sensors.findIndex((s) => s.id === item.id);

      if (index !== -1) {
        this.sensors[index] = item;
      } else {
        this.sensors.push(item);
      }
    });
  };
}

export const storageStore = new StorageStore();
